const icon = require('./icons/stretching-100.png')

export const ActiveIcon = () => {
  return <img src={icon} alt="active icon" className="w-full h-full"/>
}